module.exports = __webpack_public_path__ + "static/img/guest30.a851204.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest30.png
// module id = inCg
// module chunks = 0